import classnames from 'classnames';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { showText } from '../../app/utils';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {},
    paper: {
      width: 275,
      maxWidth: 275,
      borderRadius: 10,
      position: 'relative',
      backgroundColor: 'unset',
      boxShadow: 'unset',
    },
    notMapping: {
      width: 275,
      maxWidth: 275,
      borderRadius: 10,
      backgroundColor: 'unset',
      boxShadow: 'unset',
      minHeight: 269,
      position: 'absolute',
      top: '8%',
    },
    title: {
      textAlign: 'center',
      backgroundColor: '#f5f5f5',
      padding: '24px 24px 10px',
      border: '1px solid #f5f5f5',
      '& > h2': {
        color: '#222222',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.39',
        letterSpacing: 'normal',
      },
    },
    isNoContent: {
      borderBottomLeftRadius: '10px',
      borderBottomRightRadius: '10px',
      paddingBottom: '44px',
    },
    content: {
      backgroundColor: '#f5f5f5',
      padding: '0 24px 45px',
      borderBottomLeftRadius: '10px',
      borderBottomRightRadius: '10px',
      border: '1px solid #f5f5f5',
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.73',
      letterSpacing: '0.15px',
      textAlign: 'left',
      color: '#222',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      '& > a': {
        color: color.$2,
        textDecoration: 'underline',
      },
    },
    actions: {
      justifyContent: 'center',
      padding: '0',
      width: '100%',
      position: 'absolute',
      bottom: '18px',
      '& > div': {
        fontSize: '15px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        padding: '7px 30px',
        color: '#ffffff',
        cursor: 'pointer',
      },
    },
    actionsBlock: {
      height: 37,
    },
    cancel: {
      borderRadius: '500px',
      border: 'solid 1px #afafaf',
      backgroundColor: '#afafaf',
      marginRight: 10,
    },
    submit: {
      borderRadius: '500px',
      border: 'solid 1px #88c029',
      backgroundColor: '#88c029',
      margin: '0 !important',
    },
  }),
  {
    name: 'AwardModal',
  },
);

function AwardModal({
  isOpen,
  title,
  content,
  onCancel,
  onClick,
  cancelText,
  submitText,
  isNotMapping,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      classes={{ paper: isNotMapping ? classes.notMapping : classes.paper }}
    >
      <DialogTitle
        className={classnames(classes.title, {
          [classes.isNoContent]: !content,
        })}
      >
        {title}
      </DialogTitle>
      {content &&
        (typeof content !== 'string' ? (
          <DialogContent className={classes.content}>{content}</DialogContent>
        ) : (
          <DialogContent
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: showText(content) }}
          />
        ))}
      <div className={classes.actionsBlock}>
        <DialogActions className={classes.actions}>
          <>
            {cancelText && (
              <div className={classes.cancel} onClick={onCancel}>
                {cancelText}
              </div>
            )}
            {submitText && (
              <div className={classes.submit} onClick={onClick}>
                {submitText}
              </div>
            )}
          </>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default AwardModal;
